import { render, staticRenderFns } from "./avatarCropper.vue?vue&type=template&id=5dea7f48&scoped=true&"
import script from "./avatarCropper.vue?vue&type=script&lang=js&"
export * from "./avatarCropper.vue?vue&type=script&lang=js&"
import style0 from "./avatarCropper.vue?vue&type=style&index=0&id=5dea7f48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dea7f48",
  null
  
)

export default component.exports